<template>
  <v-alert :color="color"
           value="true"
           :style="'border-right: none !important; border-top: none !important; border-bottom: none !important; border-left: 5px solid !important; margin-left:' + marginLeft + ';'"
           outline>
    <div :style="getTextColor">
      <slot></slot>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'Advice',
  computed: {
    getTextColor() {
      if (this.textColor) {
        return `color: ${this.textColor}`
      }
      return 'color: rgba(0,0,0,0.87)'
    }
  },
  props: {
   textColor: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    marginLeft: {
      type: String,
      required: false,
      default: '10px'
    }
  },
  data() {
    return {};
  }
};
</script>

